import { jsx as _jsx } from "react/jsx-runtime";
import React, { Children } from 'react';
import styled, { css } from 'styled-components';
import { spacing } from '@nib-components/theme';
import { Box } from '../Box';
import { Columns } from '../Columns';
import { Column } from '../Column';
import { breakpoint, map } from '../breakpoint';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ContainerWrapper = styled(({ position, collapseBelow, reverse, ...rest })=>/*#__PURE__*/ _jsx(Box, {
        ...rest
    }))`
  width: 100%;

  ${({ collapseBelow, reverse })=>collapseBelow && css`
      ${breakpoint(collapseBelow)`
        ${({ position })=>position === 'left' ? css`
                & > ${PartialContainer} {
                  margin-inline-start: ${reverse ? 'unset' : 'auto'};
                  margin-inline-end: ${reverse ? 'auto' : 'unset'};
                }
              ` : css`
                & > ${PartialContainer} {
                  margin-inline-start: ${reverse ? 'auto' : 'unset'};
                  margin-inline-end: ${reverse ? 'unset' : 'unset'};
                }
              `}
      `};
    `};
`;
export const PartialContainer = styled.div`
  ${({ padding, collapseBelow })=>map(padding, (val)=>val !== undefined && collapseBelow && css`
          ${breakpoint(collapseBelow)`
            max-width: calc((75rem / 2) - ${spacing[val]});
          `};
        `)};
`;
export const SplitSection = ({ padding = {
    xs: 4,
    md: 6,
    lg: 8
}, collapseBelow = 'xs', reverse, children })=>{
    return /*#__PURE__*/ _jsx(Columns, {
        "data-mesh-component": "SPLIT-SECTION",
        collapseBelow: collapseBelow,
        reverse: reverse,
        children: Children.map(children, (child, index)=>{
            if (index < 2 && /*#__PURE__*/ React.isValidElement(child)) {
                return /*#__PURE__*/ _jsx(Column, {
                    width: "1/2",
                    flex: true,
                    children: /*#__PURE__*/ _jsx(ContainerWrapper, {
                        position: index === 0 ? 'left' : 'right',
                        collapseBelow: collapseBelow,
                        padding: padding,
                        reverse: reverse,
                        ...child.props,
                        children: /*#__PURE__*/ React.cloneElement(child, {
                            padding,
                            collapseBelow,
                            reverse
                        })
                    })
                });
            }
            return null;
        })
    });
};
SplitSection.displayName = 'SplitSection';
SplitSection.Item = PartialContainer;

//# sourceMappingURL=index.js.map